import React, {useState, useEffect, Fragment} from "react";
import { Link, useNavigate } from 'react-router-dom'
import axios from "axios";
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities"; 
import { useParams } from "react-router-dom";
import Checkbox from "./checkbox";
import { FallingLines } from 'react-loader-spinner'
import moment from 'moment'
import { association, fileUpload, officials } from "../../../apis/urls";
import OfficialPayFormUI from "./officialPayment";
import ReactPaginate from "react-paginate";
import { Grid, Modal, Text } from '@nextui-org/react';
import { userStore } from "../../../store/userStore";



const AssociationOfficialList = () => {

    const storeData = userStore();

    useEffect( ()=> {
        $('body').removeClass('').addClass('sidebar-collapsed');
        $('.sidebar-toggler').removeClass('toggle-opacity').addClass('');
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        $( ".sidebar-toggler" ).attr('disabled', false)

        OfficialListing();
        AssociationList();
        OfficialListingCount();
    },[])

    let navigate = useNavigate()

    const { assid } = useParams()


    let role = localStorage.getItem('userrole');

    // console.log("role", role)

    const [result, setResult] = useState([]);   
    const [loader, setLoader] = useState(true);  
    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);
    const [assoName, setAssoName] = useState('');
    const [totalCount, setTotalCount] = useState('');
    const [emptyItem, setEmptyItem] = useState(false);
    const [sports, setSports] = useState('');

    const AssociationList = () => {
        
        
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)
    
        const instance = axios.create({
            baseURL: association+assid,
            timeout: 1000000,
            headers: {'authorization': token}
          });
    
          instance.get('').then(res => {
            setAssoName(res.data.data.name);
            setSports(res.data.data.sport.name)
            // setLoader(false)
        });
    }



    let token = "Bearer "+localStorage.getItem('token');





    const OfficialListing = () => {
         
        const instance = axios.create({

            baseURL: officials+"/association/"+assid+'?page='+0+'&size='+10000,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{

            if(response.data.message === "Success"){  
                setResult(response.data.data.items);
                setCurrentpage(response.data.data.currentPage)
                setTotalPages(response.data.data.totalPages)
                setTotalPages(response.data.data.totalPages)
                setTotalItems(response.data.data.totalItems)
                setLoader(false);
                setEmptyItem(false)
                
            }else{
                setResult(false)
                setLoader(false);
                setEmptyItem(true)

            }

          }).catch((error) =>{
            

          });

    }





    const OfficialListingCount = () => {
         
        const instance = axios.create({

            baseURL: officials+"/count/"+assid,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{

            let count =  response.data.data;
            let arrData = [];
            let idssData = [];
            for(let newValue of count){

                if(newValue.payment_status === 'NOTPAID' && newValue.association_id === parseInt(assid) && newValue.payment_mode !== 'CHECK'){
                    arrData = [...arrData, newValue.payment_status]     
                    idssData = [...idssData, newValue.id]
                }
            }
            setTotalCount(arrData.length)
            setIsCheck(idssData)

            
          }).catch((error) =>{

          });

    }


    const [isCheck, setIsCheck] = useState([]);
    const [isCheckAll, setIsCheckAll] = useState(false);
    const [rejectedselected, setRejectSelected] = useState();


  
    const handleSelectAll = (e) => {
      setIsCheckAll(!isCheckAll);
      let arry =[];
      for(let value of result){
        if(value.payment_status ==='PAID' || (value.payment_status ==='PENDING' && value.payment_mode === 'CHECK')){
            // setIsCheck([1, 2])
        }else{
            arry = [...arry, value.id]
        }

        console.log("arrays", arry)
      }

      setIsCheck(arry)
      if (isCheckAll) {
        setIsCheck([]);
      }
    };
  
    const handleClick = (e) => {
      const { id, checked } = e.target;

      if(id){
          let selectId = parseInt(id)
          setIsCheck([...isCheck, selectId]);
          setRejectSelected(id)
          if (!checked) {
            setIsCheck(isCheck.filter((item) => item !== selectId));
          }
      }
      
    };





    const paymentSection =()=>{
        navigate("/officialpayment/"+assid+'/'+isCheck)
    }

    const handlePageClick = (event) => { console.log('EVENTSSS',event)

    $('html,body').animate({ scrollTop: 0 }, 'fast');


    const instance = axios.create({
        baseURL:  officials+"/association/"+assid+'?page='+event.selected+'&size='+10,
        timeout: 1000000,
        headers: {'authorization': token}
    });

    

    instance.get('').then(res => {

        setResult(res.data.data.items)




        setLoader(false);
        }).catch(e => {
        //console.log('errorshw',e);
        localStorage.removeItem('token')
        navigate("/")
        });

    };




    const paymentModeSelect = () => {


        const data = {
            ids: isCheck
        }

        storeData.setOfficialData({
            id: assid,
            amount: isCheck.length * 15,
            count: isCheck.length,
        })
         
        const instance = axios.create({

            baseURL: officials+"/checkpayment/"+assid,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.patch('', data).then((response) =>{
            navigate('/checkpayment/'+sports+'/'+assoName+'/'+isCheck.length)

            
          }).catch((error) =>{
            
          });

    }


    const [open, setOpen] = useState(false);
    const openModal = () => {
        setOpen(true);
        downloadList();
    }

    const closeModal = () => {
        setOpen(false);
    }


    const [list, setList] = useState([]);

    const downloadList = () => {
         
        const instance = axios.create({

            baseURL: `${fileUpload}/store/${assid}`,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{

            setList(response?.data?.data)
            
          }).catch((error) =>{
            
          });

    }

    let sl=1;

    let arr=0;

    return( 
        <div className="dashboard">
            <aside class="right-side areas">
                <div class="content-area dash-contentss">
                <div>


                    <div class="page-title-wrpr">
                    <div class="page-title-left-column">
                        <h2 class="page-title"> Official List - {assoName}</h2>
                    </div>
                    <div class="page-rightside-action-column">
                        <a onClick={openModal} data-toggle="tooltip" title="Previous Download Form" class="addbtnitem-link text-anchor" data-original-title="Add New School">&nbsp;&nbsp;<i class="icon-get_app"></i><span>&nbsp;Previous Payment Form Download&nbsp;</span>&nbsp;</a>
                        <Link to={"/addofficials/"+assid} data-toggle="tooltip" title="Create Official" class="addbtnitem-link text-anchor" data-original-title="Add New School"><i class="icon-add"></i><span>Add New Officials</span> </Link>
                    </div>
                </div>





                    <div>

                    {!loader?
                        <Fragment>
                        {!emptyItem?
                        <div class="table-wrpr mt-5"  style={{overflow:'auto'}}>

                        <table class="table sml-font">
                            <thead>
                                <tr>
                                    <th style={{paddingLeft:"15px", marginTop:"55px"}}>
                                        <div class="faculty-user checkbox-btn-options ">
                                            <span>&nbsp;</span> 
        
                                        <Checkbox
                                            type="checkbox"
                                            name="selectAll"
                                            id="selectAll"
                                            handleClicks={handleSelectAll}
                                            isChecked={isCheckAll}
                                        />   
        
        
        
                                        </div>
                                    </th>
                                    <th style={{paddingLeft:"5px"}}>Name</th>
                                    <th style={{paddingLeft:"5px"}}>Best Contact Phone</th>
                                    <th style={{paddingLeft:"5px"}}>Email</th>
                                    <th style={{paddingLeft:"5px"}}>Payment Amount</th>
                                    <th style={{paddingLeft:"5px"}}>Payment Status</th>
                                </tr>
                            </thead>
                        <tbody>
           
                    
                    { result?(
                        <Fragment>
                        {result.map((item,index, ids, name)=> (
                                
                            <Fragment>
                                <Fragment>
        
                                <tr> 
        
        
                        <td class="checkbox-cntnr">
                            <div class="faculty-user checkbox-btn-options">
                                <span>&nbsp;</span>
                                    <Checkbox
                                            disableValue={item.payment_status==='PAID'?true:  
                                            (item.payment_mode === 'CHECK' && item.payment_status==='NOTPAID'?
                                            true:false)}
                                            key={ids}
                                            type="checkbox"
                                            id={item.payment_status === "NOTPAID" && item.id}
                                            // payment={item.payment_status}
                                            handleClicks={handleClick}
                                            isChecked={isCheck.includes(item.id)}
                                            className="select-individual-check"
                                    />
                                    </div>
                                    </td>
                                        
                
                                            <td data-table-heading="Name" style={{paddingLeft:"5px"}}>{item.firstname +' '+ item.lastname}</td>
                                            <td data-table-heading="DOB" style={{paddingLeft:"5px"}}>{item.work_phone}</td>
                                            <td data-table-heading="Age" style={{paddingLeft:"5px"}}>{item.email}</td>
                                            <td data-table-heading="Age" style={{paddingLeft:"5px"}}>$ 15</td>
                                            <td data-table-heading="Age" style={{paddingLeft:"5px"}}>
                                                {
                                                    item.payment_status === 'NOTPAID'?
                                                    <div><span style={{color:'#FF0000', fontWeight:'600', fontSize:'15px', padding:'3px', paddingLeft:'10px', paddingRight:'10px', borderRadius:'5px'}}>NOT PAID</span></div>:  
                                                    item.payment_status === 'PAID'?
                                                    <div><span style={{color:'#2CA212', fontWeight:'600', fontSize:'15px', padding:'3px', paddingLeft:'10px', paddingRight:'10px', borderRadius:'5px'}}>PAID</span></div>:
                                                    item.payment_status === 'PENDING' &&
                                                    <div><span style={{color:'#0069FF', fontWeight:'600', fontSize:'15px', padding:'3px', paddingLeft:'10px', paddingRight:'10px', borderRadius:'5px'}}>{item.payment_mode === 'CHECK'?"CHECK":"PENDING"}</span></div>                                          }
                                            </td>
                                            <td data-table-heading="Actions" >
        
                    
                                        <div class="list-action-wrpr text-right roundicons-text" >
                                        <Link  to={"/officialview/"+assid+'/'+item.id} title="View" ><i class="view icon-eye" style={{marginLeft:"-80px"}}></i><span style={{marginLeft:"-80px"}}>View</span></Link>
            
                                        </div>
                                    </td>
                    
                                </tr>
                                </Fragment>
        
                                </Fragment>))}
                                </Fragment>
                                )
                                
                                :null
                                    }
                            </tbody>
                        </table> 

                    </div> :
                        <h1 style={{textAlign:'center', paddingTop:'15%', color:'#fff'}}>Sorry! No Officials Found</h1>
                    }</Fragment>
                    
                    
                    :

                        <div class="container" style={{alignItems:'center', marginLeft:'45%', marginTop:'20%'}}>
                        <div className="fp-container">
                            <FallingLines
                                color="#fff"
                                width="50"
                                visible={true}
                                ariaLabel='falling-lines-loading'
                                />
                        </div>
                        </div>

                    }
                </div>               






    {isCheck.length ===0?null:

    <Grid.Container style={{position:'absolute',bottom:'5%'}}>
        <Grid xs={8}>

            <div style={{
                //   position:'fixed', 
                // bottom:'5%', 
                //   left:'2%',
                background:'#fff', 
                fontSize:'14px',
                borderRadius:'10px',
                width:'35%',
                height:'80%',
                cursor:'pointer',
                boxShadow:'0px 0px 12px -6px #000'
                }}
                //   onClick={paymentSection}
                >
                    <div>
                        <p style={{textAlign:'center',color:'#0072F5', fontWeight:'bold', minWidth: '100%', padding:'18px'}}>
                        Total Amount Due {isCheck.length} X $ 15 = $ {isCheck.length * '15'}
                        </p>
                    </div>
            </div>

        </Grid>
        <Grid  xs={2} style={{justifyContent:'flex-end'}}>
            <div style={{
                background:'#2528ea', 
                width:'60%',                
                fontSize:'14px',
                height:'80%',
                borderRadius:'10px',
                cursor:'pointer',
                marginRight:'10%',
                boxShadow:'0px 0px 12px -6px #000'
                }}                
                onClick={paymentModeSelect}
                >
                <div>
                    <p style={{textAlign:'center',color:'#fff', fontWeight:'bold',  margin: 'auto', width: '100%', padding:'18px'}}>
                        Check Payment
                    </p>
                </div>
            </div>
        </Grid>

        <Grid  xs={2}>
            <div style={{
                background:'#2528ea', 
                fontSize:'14px',
                width:'60%',
                borderRadius:'10px',
                height:'80%',
                cursor:'pointer',
                boxShadow:'0px 0px 12px -6px #000'
                }}
                onClick={paymentSection}
                >
                    <div>
                        <p style={{textAlign:'center',color:'#fff', fontWeight:'bold',  margin: 'auto', width: '100%', padding:'18px'}}>
                        Online Payment
                        </p>
                    </div>
            </div>
        </Grid>
      </Grid.Container>
      }


      <Modal
        width="800px"
        blur
        scroll
        closeButton
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
        <Modal.Header>
            <Text b size="16px">
                Previous Check Payment History
            </Text>
        </Modal.Header>
        <Modal.Body>
            <table class="table table-rules">
                <thead>
                    <tr className="rules-table-head">
                        <th>Sl No.</th>
                        <th>Created Date</th>
                        <th>Amount</th>
                        <th>Officials Count</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list?.map((item, index) =>(
                        <tr className="rules-table-content">
                            <td>{index + 1}</td>
                            <td>{moment(item?.createdAt).format('MM-DD-YYYY')}</td>
                            <td>
                                <div>${item?.amount}</div>
                            </td>
                            <td>
                                {item?.count}
                            </td>

                            <td>
                                <a href={item?.file}>
                                    <i className="icon-download"></i>
                                    <span>&nbsp; &nbsp; Download</span>
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </Modal.Body>
    </Modal>

     

                    {/* {result?
                    <div class="pagination-wrpr">
                        <ReactPaginate
                                className="pagination page"
                                pageClassName="page-item"
                                activeClassName="active"
                                nextLabel=">"
                                previousLabel="<"
                                previousClassName="page-link p-link"
                                nextClassName="page-link p-link"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={10}
                                pageCount={totalPages}
                                renderOnZeroPageCount={1}
                            />
                    </div>:null} */}




                    </div>

                </div>
            </aside>
        </div>
    )
};

export default AssociationOfficialList;
